<template>
  <v-app>
    <v-alert
      class="alert-cont"
      :value="alert"
      transition="slide-y-transition"
      type="success"
      @click="goTo('/easy-to-use')"
    >
      <div class="button-cont">
        <div>앱처럼 사용하기 (click)</div>
        <v-icon @click.stop="offAlert">close</v-icon>
      </div>
    </v-alert>
    <div class="genre-search-page">
      <v-tabs
        v-model="active"
        slider-color="primary"
        class="search-cont"
      >
        <v-tab ripple>태그 검색</v-tab>
        <v-tab ripple>문자열 검색</v-tab>
        <v-tab-item>
          <tag-search
              :genre-list="genreList"
              @changeValue="searchByTag"
          >
          </tag-search>
        </v-tab-item>
        <v-tab-item>
          <text-search
              :genre-list="genreList"
              @changeValue="searchByCode"
          ></text-search>
        </v-tab-item>
      </v-tabs>
      <div class="list-cont">
        <list-item
          :items="getFilteredList"
        ></list-item>
      </div>
      <div class="bottom-cont"></div>
      <div class="top-button" @click="goToTop" :class="{show: !isScrollTop}">
        <v-btn color="error" fab dark>
          <v-icon>keyboard_arrow_up</v-icon>
        </v-btn>
      </div>
    </div>
  </v-app>
</template>

<script>
  import genreList from '@/assets/genre-code.js';
  import TextSearch from './components/TextSearch';
  import TagSearch from './components/TagSearch';
  import ListItem from './components/ListItem';
  import { filter } from "@/assets/utils";
  import Cookies from 'js-cookie';

  export default {
    components: {
      TextSearch,
      ListItem,
      TagSearch
    },
    data() {
      return {
        active: 0,
        genreList: [],
        isScrollTop: true,
        code: '',
        tags: [],
        alert: false
      }
    },
    created () {
      if (!Cookies.get('isOffAlert_01')) {
        setTimeout(() => this.alert = true, 2000);
      }
    },
    mounted () {
      this.genreList = genreList;
      window.addEventListener('scroll', this.setIsScrollTop);
    },
    destroyed () {
      window.removeEventListener('scroll', this.setIsScrollTop);
    },
    methods: {
      setIsScrollTop () {
        this.isScrollTop = window.scrollY <= 0;
      },
      searchByCode (code) {
        this.code = code;
      },
      searchByTag (tags) {
        this.tags = tags;
      },
      goTo (path) {
        this.$router.push({path});
      },
      offAlert () {
        gtag('event', '앱배너 끄기', {
          'event_category': '앱배너 끄기',
          'event_label': `앱배너 끄기`
        });
        this.alert = false;
        Cookies.set('isOffAlert_01', true, { expires: 999999, path: '/' });
      },
      goToTop () {
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0
        })
      }
    },
    computed: {
      getFilteredList () {
        if (this.active === 1 && this.code) return filter(this.genreList, (i) => i.code === this.code);
        else if (this.active === 0 && this.tags.length > 0) {
          return filter(this.genreList, (i) => {
            for (let tag of this.tags) {
              if (i['genre-ko'].indexOf(tag) >= 0) return true;
            }
          });
        }
        return this.genreList;
      }
    },
  }
</script>

<style lang="scss" scoped>
.alert-cont {
  width: 100%;
  margin: 0;
  cursor: pointer;

  .button-cont {
    display: flex;
    justify-content: space-between;
  }
}
.genre-search-page {
  background-color: white;


  .search-cont {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 12px 0 12px;
  }
  .bottom-cont {
    min-height: 200px;
  }
  .top-button {
    position: fixed;
    bottom: 40px;
    right: 20px;
    transform: scale(0);
    transition: transform .3s ease-in-out;
  }
  .show {
    transform: scale(1);
  }
}
</style>
